import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';

import App from './App';
import './styles/main.scss';

ReactDOM.render(
  <HashRouter>
    <App />
  </HashRouter>,
  document.getElementById('root'),
);
